import React, { useEffect, useState } from 'react';
import { Button, makeStyles, MenuItem, IconButton } from '@material-ui/core';
import { Link } from 'react-router-dom';
import MenuOpener from '../utils/MenuOpener';
import UserAvatar from '../utils/UserAvatar';
import { useLogoutAction, useUser } from '../utils/auth';
import { clearStoredPath } from '../utils/redirect/LocalRedirectUrlStorage';
import { FluentProfileMenuCard } from './FluentProfileMenuCard';
import { clearStoredExternalPath } from '../utils/redirect/ExternalRedirectUrlStorage';
import { useSingleLogout } from '../utils/auth/useSingleLogout';

const useStyles = makeStyles(theme => ({
  root: {},
  avatar: {
    background: theme.palette.secondary.main,
    height: '32px',
    width: '32px',
  },
}));

const IS_LOCAL_AUTH = process.env.REACT_APP_LOCAL_AUTH === 'true';

const UserWrapper = props => {
  const classes = useStyles();
  const { className, tenant, returnTo, appContent, userAvatar, userHasAccessToTenant, ...other } = props;

  const user = useUser();

  const [userData, setUserData] = useState(user);

  // const logout = useLogoutAction();
  const singleLogout = useSingleLogout();

  useEffect(() => {
    if (!user) {
      return;
    }
    setUserData(user);
  }, [user, setUserData]);

  if (!user) return null;

  return (
    <div className={classes.root}>
      {user ? (
        <MenuOpener
          button={
            <IconButton>
              <UserAvatar
                name={user?.name}
                email={user?.email}
                size="toolbar"
                className={classes.avatar}
              />
            </IconButton>
          }
          menuProps={{
            keepMounted: true,
            getContentAnchorEl: null,
            variant: 'menu',
            anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            transformOrigin: { vertical: 'top', horizontal: 'right' },
          }}
        >
          <FluentProfileMenuCard
            userTenants={
              process.env.REACT_APP_UNITY_TENANT_ID === ''
                ? tenant?.options
                : userHasAccessToTenant
                ? tenant?.options?.filter(option => {
                    return (
                      option.tenantId === process.env.REACT_APP_UNITY_TENANT_ID
                    );
                  })
                : []
            }
            currentTenant={tenant?.current}
            user={user}
            setUser={tenant?.onSelect}
            logout={singleLogout}
            displayProfileButton={!IS_LOCAL_AUTH}
            // unityUrl={unityUrl}
          />
        </MenuOpener>
      ) : (
        <Button
          component={Link}
          to={{ pathname: '/login', state: { returnTo } }}
          color="inherit"
        >
          Sign in
        </Button>
      )}
    </div>
  );
};
export default UserWrapper;
